"use client";

import { useEffect } from "react";
import { HOMEPAGE } from "@/lib/utils";
import { t } from "@/lib/localization";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
            <div className="text-center">
                <p className="text-base font-semibold text-blue-600">
                    {t("error.page.title")}
                </p>
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                    {t("error.page.heading")}
                </h1>
                <p className="mt-6 text-base leading-7 text-gray-600">
                    {t("error.page.description")}
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                    <button
                        onClick={() => {
                            reset();
                        }}
                        className="rounded-md bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                    >
                        {t("error.page.retry")}
                    </button>
                    <a
                        href={HOMEPAGE}
                        className="text-sm font-semibold text-gray-900"
                    >
                        {t("error.page.home")}
                        <span aria-hidden="true">&larr;</span>
                    </a>
                </div>
            </div>
        </main>
    );
}
